import CreateAxiosInstance from './axiosConfig';
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);

export async function getUserPacketTemplates({ templateFilters, searchText, page, page_size }) {
  const queryParams = [];

  if (templateFilters && Object.keys(templateFilters).length > 0) {
    Object.keys(templateFilters).forEach((key) => {
      queryParams.push(`${key}=${templateFilters[key]}`);
    });
  }
  if (searchText) {
    queryParams.push(`search=${searchText}`);
  }
  if (page) {
    queryParams.push(`page=${page}`);
  }
  if (page_size) {
    queryParams.push(`page_size=${page_size}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await APIClient.get(`/user_packet_template/user${queryString}`, {
    customErrorHandler: function (error) {
      alert('Error getting templates:\n' + error?.response?.data?.error);
    },
  });
}

export async function createUserPacketTemplate(templateName, packetId, description = '') {
  return await APIClient.post('/user_packet_template/user', {
    templateName,
    packetId,
    description,
  });
}

export async function deleteUserPacketTemplate(templateId) {
  return await APIClient.delete('/user_packet_template/user', {
    data: {
      templateId,
    },
  });
}

export async function updateUserPacketTemplate(templateId, data) {
  return await APIClient.patch('/user_packet_template/user', {
    operation: 'update_template',
    templateId,
    data,
  });
}

export async function updateUserPacketTemplateFromPacket(templateId, packetId) {
  return await APIClient.patch('/user_packet_template/user', {
    operation: 'update_from_packet',
    templateId,
    packetId,
  });
}

export async function shareTemplateWithColleagues(templateId, colleagues) {
  return await APIClient.post(`/user_packet_template/${templateId}/share`, { colleagues });
}

export async function getSharedTemplate(templateId) {
  return await APIClient.get(`/user_packet_template/shared?template_id=${templateId}`);
}

export async function saveSharedTemplate(templateId) {
  return await APIClient.post('/user_packet_template/shared', { template_id: templateId });
}

export async function saveAllSharedTemplates(templateIds) {
  return await APIClient.post('/user_packet_template/shared/multiple', {
    template_ids: templateIds,
  });
}
